// LandingPage.js
import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./LandingFigma.css";

// ADD LENIS IMPORT HERE
import Lenis from '@studio-freight/lenis';

export default function LandingPage() {
  const navigate = useNavigate();
  const [activeFaq, setActiveFaq] = useState(0);

  // ✅ S3 base host from .env (React env must start with REACT_APP_)
  // Example:
  // REACT_APP_S3_IMAGES_BASE=https://bucket-datastore-mark1.s3.ap-south-1.amazonaws.com/Images
  const IMAGE_BASE = (process.env.REACT_APP_S3_IMAGES_BASE || "").replace(/\/$/, "");

  // ✅ helper to build image url
  const img = (fileName) => {
    const url = `${IMAGE_BASE}/${fileName}`;
    console.log("Generated URL:", url); // Debug log
    return url;
  };
  // ✅ Debug: Log the base URL on component mount
  useEffect(() => {
    console.log("IMAGE_BASE:", IMAGE_BASE);
    console.log("Sample URL:", img("logo-header.png"));
  }, []);

  // ADD THIS NEW useEffect FOR SMOOTH SCROLLING
  useEffect(() => {
    const lenis = new Lenis({
      lerp: 0.08,
      wheelMultiplier: 1.2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  const faqs = [
    {
      q: "What Kind Of Services We Offer",
      a: "We offer expert washing machine and fridge repair services, delivering fast, reliable, and affordable solutions to keep your home appliances running smoothly every day.",
    },
    {
      q: "What Kind Of Services We Offer",
      a: "We offer expert washing machine and fridge repair services, delivering fast, reliable, and affordable solutions.",
    },
    {
      q: "What Kind Of Services We Offer",
      a: "We offer expert washing machine and fridge repair services, delivering fast, reliable, and affordable solutions.",
    },
    {
      q: "What Kind Of Services We Offer",
      a: "We offer expert washing machine and fridge repair services, delivering fast, reliable, and affordable solutions.",
    },
    {
      q: "What Kind Of Services We Offer",
      a: "We offer expert washing machine and fridge repair services, delivering fast, reliable, and affordable solutions.",
    },
  ];

  const stopLink = (e) => e.preventDefault();

  const painCards = [
    { num: "01", title: "Posting on each platform separately.", img: img("pain-1.png") },
    { num: "02", title: "Struggling with best posting time.", img: img("pain-2.png") },
    { num: "03", title: "Lack of unified performance insights.", img: img("pain-3.png") },
    { num: "04", title: "Writing the same caption reputedly", img: img("pain-4.png") },
  ];

  // Add onError handler to images for debugging
  const handleImageError = (e) => {
    console.error("Failed to load image:", e.target.src);
    // Optionally set a fallback image
    // e.target.src = '/path/to/fallback-image.png';
  };

  return (
    <>
      {/* HEADER */}
      <header className="site-header">
        <div className="header-inner">
          <div className="logo">
            <img src={img("logo-header.png")} alt="Quick Socials" />
          </div>

          <input type="checkbox" id="menu-toggle" />
          <label htmlFor="menu-toggle" className="menu-icon" aria-label="Toggle menu">
            <span></span>
            <span></span>
            <span></span>
          </label>

          <nav className="main-nav">
            <a href="#home" className="active">
              HOME
            </a>
            <a href="#about">ABOUT</a>
            <a href="#solutions">SOLUTIONS</a>
            <a href="#features">FEATURES</a>
            <a href="#pricing">PRICING</a>
          </nav>

          <div className="header-actions">
            <button className="btn-outline" onClick={() => navigate("/login")}>
              Log In
            </button>
            <button className="btn-primary" onClick={() => navigate("/signup")}>
              Sign Up
            </button>
          </div>
        </div>
      </header>

      {/* HERO */}
      <section className="hero" id="home">
        {/* Floating cards LEFT */}
        <img src={img("left-card-1.png")} className="floating-img left-img img-1" alt="" />
        <img src={img("left-card-2.png")} className="floating-img left-img img-2" alt="" />

        {/* Floating cards RIGHT */}
        <img src={img("right-card-1.png")} className="floating-img right-img img-3" alt="" />
        <img src={img("right-card-2.png")} className="floating-img right-img img-4" alt="" />

        <div className="hero-content">
          <h1 className="hero-title">
            Schedule{" "}
            <span className="avatars">
              <img src={img("herro-title.png")} alt="" />
            </span>{" "}
            Smarter
            <br />
            <span className="social-group">
              <img src={img("hero-icons.png")} alt="Social platforms" />
            </span>
            <span className="highlight">Post Everywhere</span>
          </h1>

          <p className="hero-subtitle">
            Plan projects, stay on track, and deliver on
            <br />
            time without overworking your team.
          </p>

          <button className="hero-btn" onClick={() => navigate("/signup")}>
            Try Now - Free!
          </button>
        </div>

        {/* Dashboard mockup */}
        <div className="hero-dashboard">
          <img src={img("dashboard.png")} alt="Dashboard" />
        </div>
      </section>

      {/* PAIN POINTS */}
      <section className="pain-section" id="about">
        <p className="section-label">Pain Points</p>
        <h2 className="section-title">The Pain of Manual Posting</h2>

        <div className="pain-grid">
          {painCards.map((card) => (
            <div className="pain-card" key={card.num}>
              <span className="pain-number">{card.num}</span>
              <div className="pain-head">
                <span className="pain-dot"></span>
                <h3>{card.title}</h3>
              </div>
              <div className="pain-body">
                <img src={card.img} alt="" />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* FEATURES / SOLUTION */}
      <section className="features-section" id="features">
        <div className="features-wrapper">
          <div className="section-head">
            <span className="section-tag">Solution</span>
            <h2>
              What Makes Us
              <br />
              Stand Out?
            </h2>
          </div>

          <div className="features-grid">
            <div className="feature-card">
              <div className="ai-person">
                <img src={img("ai-scheduler.png")} alt="AI Smart Scheduler" />
              </div>
              <h4>AI Smart Scheduler</h4>
              <p>
                Maximize reach by auto-scheduling posts during your audience’s peak engagement times.
              </p>
            </div>

            <div className="feature-card">
              <img src={img("social-icons-group.png")} alt="Social icons" />
              <h4>Cross-Platform Posting</h4>
              <p>Publish to Instagram, LinkedIn, Facebook, YouTube, and X in one click.</p>
            </div>

            <div className="feature-card">
              <div className="image-rounded">
                <img src={img("img-posting.png")} alt="Posting" />
              </div>
              <h4>
                We’ll Handle Your <span>Posting</span>
              </h4>
            </div>

            <div className="feature-card">
              <h3 className="handwritten">Hi, There!</h3>
              <h4>AI Caption & Hashtag Generator</h4>
              <p>Generate catchy on-brand captions for every platform to save valuable time.</p>
            </div>

            <div className="feature-card brand-card">
              <img src={img("logo-white.png")} alt="Quick Socials" />
            </div>

            <div className="feature-card">
              <div className="stats">
                <span className="stat red">❤ 20</span>
                <span className="stat dark">👤 12</span>
                <span className="stat blue">💬 10</span>
              </div>
              <h4>Analytics & Insights</h4>
              <p>Track all your performance and engagement metrics within one clean dashboard.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section" id="solutions">
        <div className="cta-content">
          <h2 className="cta-title">
            Get more <br />
            productive Posting
          </h2>

          <p className="cta-description">
            With Quick Social, connect your social profiles, create once, and let AI handle timing,
            captions, and hashtags so you stay focused.
          </p>

          <button className="cta-button" onClick={() => navigate("/signup")}>
            <span className="cta-dot"></span>
            Start Now - Free
          </button>
        </div>
      </section>

      {/* REVIEWS */}
      <section className="reviews-section">
        <div className="reviews-container">
          <div className="reviews-heading">
            <span className="reviews-label">Reviews</span>
            <h2>
              What People Have To <br /> Say About Us
            </h2>
          </div>

          <div className="reviews-grid">
            {/* Column 1 */}
            <div className="reviews-column mask-bottom">
              <div className="reviews-track scroll-down">
                {[
                  { txt: "“Worth every penny.”", img: 11 },
                  { txt: "“One of the nicest, most wonderful apps I use fifty+ times a day.”", img: 12 },
                  { txt: "“Perfect Mac app. Worth every penny.”", img: 13 },
                  { txt: "“The best productivity app I own.”", img: 18 },
                ].map((r, idx) => (
                  <div className="review-card" key={idx}>
                    <p>{r.txt}</p>
                    <div className="review-user">
                      <img src={`https://i.pravatar.cc/100?img=${r.img}`} alt="" />
                      <div>
                        <strong>Jillian</strong>
                        <span>Community Manager</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Column 2 */}
            <div className="reviews-column mask-top hide-mobile">
              <div className="reviews-track scroll-up">
                {[
                  { txt: "“Amazing, fast, and extremely reliable.”", img: 14 },
                  { txt: "“The cleanest UI I’ve used in years.”", img: 15 },
                  { txt: "“I rely on this tool daily.”", img: 16 },
                  { txt: "“Simply outstanding.”", img: 19 },
                ].map((r, idx) => (
                  <div className="review-card" key={idx}>
                    <p>{r.txt}</p>
                    <div className="review-user">
                      <img src={`https://i.pravatar.cc/100?img=${r.img}`} alt="" />
                      <div>
                        <strong>Jillian</strong>
                        <span>Community Manager</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Column 3 */}
            <div className="reviews-column mask-bottom hide-tablet">
              <div className="reviews-track scroll-down">
                {[
                  { txt: "“Worth every penny.”", img: 17 },
                  { txt: "“Perfect Mac app. Worth every penny.”", img: 13 },
                  { txt: "“The best productivity app I own.”", img: 18 },
                  { txt: "“Simply outstanding.”", img: 19 },
                ].map((r, idx) => (
                  <div className="review-card" key={idx}>
                    <p>{r.txt}</p>
                    <div className="review-user">
                      <img src={`https://i.pravatar.cc/100?img=${r.img}`} alt="" />
                      <div>
                        <strong>Jillian</strong>
                        <span>Community Manager</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section className="pricing-section" id="pricing">
        <div className="pricing-container">
          <span className="pricing-label">Pricing</span>
          <h2 className="pricing-title">
            Choose a plan that
            <br />
            fits your team.
          </h2>

          <p className="pricing-subtitle">Choose your billing</p>

          <div className="billing-toggle">
            <span className="billing-option">Month</span>
            <span className="billing-option active">Yearly</span>
            <span className="save-badge">20% Save</span>
          </div>

          <div className="pricing-grid">
            <div className="pricing-card">
              <div className="plan-icon light">👥</div>
              <h3>Individuals</h3>
              <h4>$9.99</h4>
              <p className="per">Per month</p>

              <ul>
                <li>Unlimited projects, clients</li>
                <li>Personal desktop activity tracking</li>
                <li>You can add 05 members on your project</li>
              </ul>

              <button className="btn-outline" onClick={() => navigate("/signup")}>
                Get Buy
              </button>
            </div>

            <div className="pricing-card featured">
              <div className="plan-icon solid">✓</div>
              <h3>Elite Team</h3>
              <h4>$12.99</h4>
              <p>Per month</p>

              <span className="trial">15 days free trials!</span>

              <ul>
                <li>Everything in Starter +</li>
                <li>Centralized control of labor costs and billable rates</li>
                <li>Single sign-on (SSO)</li>
              </ul>

              <button className="btn-solid" onClick={() => navigate("/signup")}>
                Get Buy
              </button>
            </div>

            <div className="pricing-card">
              <div className="plan-icon light">🧳</div>
              <h3>Startup</h3>
              <h4>Contact</h4>
              <p className="per">us to pre order</p>

              <ul>
                <li>Everything in Premium +</li>
                <li>Manage multiple workspaces under one Organization</li>
                <li>Expert training and assistance</li>
              </ul>

              <button className="btn-outline" onClick={stopLink}>
                Contact Now
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="faq-section">
        <div className="faq-container">
          <span className="faq-label">Reviews</span>
          <h2 className="faq-title">FAQs</h2>

          <div className="faq-list">
            {faqs.map((f, idx) => {
              const open = activeFaq === idx;
              return (
                <div
                  key={idx}
                  className={`faq-item ${open ? "active" : ""}`}
                  onClick={() => setActiveFaq(idx)}
                >
                  <div className="faq-left">{String(idx + 1).padStart(2, "0")}</div>

                  <div className="faq-content">
                    <h3 className="faq-question">{f.q}</h3>
                    <div className="faq-answer">{f.a}</div>
                  </div>

                  <button className="faq-toggle" type="button">
                    {open ? "−" : "+"}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA2 */}
      <section className="cta2">
        <div className="cta2-box">
          <span className="cta-shape shape-left"></span>
          <span className="cta-shape shape-right"></span>

          <div className="cta2-content">
            <h2 className="cta2-title">
              Begin
              <span className="cta-img pill-img">
                <img src={img("cta2-1.png")} alt="User" />
              </span>
              Smart
              <br />
              Scheduling
              <span className="cta-img oval-img">
                <img src={img("cta2-2.png")} alt="Scheduling" />
              </span>
              Now!
            </h2>

            <button className="cta2-btn" onClick={() => navigate("/signup")}>
              <span className="cta-dot"></span>
              Start Now
            </button>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="site-footer">
        <div className="footer-top">
          <div className="footer-brand">
            <img src={img("footer-logo.png")} alt="Quick Socials" className="footer-logo" />
          </div>

          <div className="footer-col">
            <h4>Explore</h4>
            <ul>
              <li>
                <a href="#features">Features</a>
              </li>
              <li>
                <a href="#pricing">Pricing</a>
              </li>
              <li>
                <a href="/" onClick={stopLink}>
                  Blog
                </a>
              </li>
              <li>
                <a href="/" onClick={stopLink}>
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Keep in touch</h4>
            <form className="footer-form" onSubmit={(e) => e.preventDefault()}>
              <input type="email" placeholder="email address" />
              <button type="submit">Subscribe</button>
            </form>

            <div className="footer-social">
              <p>Follow us</p>
              <div className="social-icons">
                <a href="/" onClick={stopLink}>
                  in
                </a>
                <a href="/" onClick={stopLink}>
                  f
                </a>
                <a href="/" onClick={stopLink}>
                  𝕏
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>Copyright © QuickSocials 2025 All Rights Reserved</p>

          <ul className="footer-links">
            <li>
              <a href="/" onClick={stopLink}>
                Cookies
              </a>
            </li>
            <li>
              <a href="/" onClick={stopLink}>
                Privacy policy
              </a>
            </li>
            <li>
              <a href="/" onClick={stopLink}>
                Security
              </a>
            </li>
            <li>
              <a href="/" onClick={stopLink}>
                Legal documents
              </a>
            </li>
          </ul>
        </div>
      </footer>
    </>
  );
}
